import React, { useEffect } from 'react'

export interface MaintenanceWarning {
  active: boolean
  reason?: string
  estimatedEnd?: string | null
  maintenanceStart?: string | null
  countdownMinutes: number
  secondsLeft: number
}

/** Recover OTP/LINE bridge callbacks that landed on document URL instead of hash route. */
export const LineBridgeHashRedirect: React.FC = () => {
  useEffect(() => {
    const docSearch = new URLSearchParams(window.location.search)
    const lineBridge = docSearch.get('lineBridge')
    if (!lineBridge) return

    const hash = window.location.hash
    if (hash.includes('lineBridge=')) return

    const params = new URLSearchParams()
    for (const key of ['lineBridge', 'flowId', 'firebaseUid', 'sessionId', 'errorMessage']) {
      const value = docSearch.get(key)
      if (value) params.set(key, value)
    }

    const query = params.toString()
    const targetHash = query ? `#/register?${query}` : '#/register'
    window.location.replace(`${window.location.origin}${window.location.pathname}${targetHash}`)
  }, [])

  return null
}

export const MaintenanceWarningOverlay: React.FC<{ warning: MaintenanceWarning }> = ({ warning }) => {
  const mins = Math.floor(warning.secondsLeft / 60)
  const secs = warning.secondsLeft % 60
  const pct = Math.max(0, (warning.secondsLeft / Math.max(1, warning.countdownMinutes * 60)) * 100)
  return (
    <div className="htg-maint-warn">
      <div className="htg-maint-warn__card">
        <h2>ระบบกำลังจะปิดให้บริการชั่วคราว</h2>
        {warning.reason ? <p className="htg-maint-warn__reason">{warning.reason}</p> : null}
        <div className="htg-maint-warn__timer">
          <p>ระบบจะ logout อัตโนมัติใน</p>
          <div className={warning.secondsLeft <= 30 ? 'is-urgent' : ''}>
            {String(mins).padStart(2, '0')}:{String(secs).padStart(2, '0')}
          </div>
        </div>
        <div className="htg-maint-warn__bar">
          <span style={{ width: `${pct}%` }} className={warning.secondsLeft <= 30 ? 'is-urgent' : ''} />
        </div>
      </div>
    </div>
  )
}
